import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Smartphone, MessageCircle } from "lucide-react";
import { Btn, Card, ScoreRing, Bar, Pill, Footer, Logo } from "./ui";
import { AREA_LABEL, OBIETTIVO_LABEL, CLUB_BASE } from "./clubApi";

export const InstallHint = () => (
  <Card className="flex gap-3 items-start border-[#E5B13A]/30" data-testid="install-hint">
    <Smartphone size={20} className="text-[#E5B13A] mt-0.5 shrink-0" />
    <div className="text-sm">
      <p className="font-semibold">Salva la tua pagina sul telefono</p>
      <p className="text-[#9A948A] mt-1">iPhone: tocca <b className="text-[#F4EFE6]">Condividi</b> → <b className="text-[#F4EFE6]">Aggiungi alla schermata Home</b>. Android: menu <b className="text-[#F4EFE6]">⋮</b> → <b className="text-[#F4EFE6]">Installa app</b>. Avrai l'icona Diamond Club con il tuo percorso.</p>
    </div>
  </Card>
);

export default function TestResult({ data }) {
  const { profilo, nome, token, incaricata, risposte } = data;
  const first = nome.split(" ")[0];
  const incFirst = incaricata?.name?.split(" ")[0] || "la tua incaricata";
  const waText = encodeURIComponent(`Ciao ${incFirst}, ho fatto il test del Diamond Club: indice ${profilo.indice}. Ecco la mia pagina: ${window.location.origin}${CLUB_BASE}/c/${token}`);
  return (
    <div className="mx-auto max-w-md px-6 pt-8 pb-10" data-testid="test-result">
      <div className="flex items-center gap-3"><Logo size={32} /><span className="font-club-display text-lg">Diamond Club</span></div>
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="mt-10 flex flex-col items-center text-center">
        <p className="text-xs uppercase tracking-[0.22em] text-[#9A948A]">{first}, ecco da dove parti</p>
        <div className="mt-6"><ScoreRing value={profilo.indice} /></div>
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {(risposte?.obiettivi || []).map((o) => <Pill key={o}>{OBIETTIVO_LABEL[o] || o}</Pill>)}
        </div>
      </motion.div>
      <Card className="mt-8 space-y-3">
        <p className="text-xs uppercase tracking-[0.2em] text-[#9A948A] mb-2">Le tue aree</p>
        {Object.entries(profilo.aree).map(([k, v]) => <Bar key={k} label={AREA_LABEL[k]} value={v} />)}
      </Card>
      <div className="mt-8">
        <p className="font-club-display text-2xl">Tre abitudini da cui partire</p>
        <p className="text-sm text-[#9A948A] mt-1">Scelte sulle tue aree più deboli. Da domani, non da lunedì.</p>
        <div className="mt-4 space-y-3">
          {profilo.abitudini.map((h, i) => (
            <motion.div key={h.area} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 + i * 0.12 }}>
              <Card className="flex gap-4" data-testid={`habit-${h.area}`}>
                <span className="font-club-display text-2xl text-[#E5B13A]">0{i + 1}</span>
                <div><Pill tone="muted">{h.label}</Pill><p className="mt-2 text-sm leading-relaxed">{h.testo}</p></div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="mt-8 space-y-3">
        <InstallHint />
        <Card>
          <p className="font-semibold">Cosa succede adesso</p>
          <p className="text-sm text-[#9A948A] mt-1">{incFirst} vede il tuo risultato e nei prossimi giorni prepara il tuo percorso. Lo troverai qui, sulla tua pagina.</p>
          <Link to={`${CLUB_BASE}/c/${token}`} data-testid="go-to-page-link"><Btn variant="dark" className="mt-4 w-full">Apri la mia pagina</Btn></Link>
          {incaricata?.whatsapp && (
            <a href={`https://wa.me/${incaricata.whatsapp}?text=${waText}`} target="_blank" rel="noreferrer" data-testid="wa-incaricata-link">
              <Btn variant="wa" className="mt-2 w-full"><MessageCircle size={16} /> Scrivi a {incFirst}</Btn>
            </a>
          )}
        </Card>
      </div>
      <Footer />
    </div>
  );
}
